<div class="loader" *ngIf="totalRequest > 0">
    <div class="loading">
        <img src="/assets/img/loading.svg" alt="">
    </div>
</div>